import React from 'react';
import PropTypes from 'prop-types';
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import {isEmpty, extractWorkSheetData, getWithExpiry} from "../../../globals/GlobalFunctions";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import axios from 'axios';
import {refreshToken} from "../../../globals/GlobalFunctions";
import Autocomplete from "@mui/material/Autocomplete";
import {GlobalConstants} from "../../../globals/GlobalConstants";
import TextField from "@mui/material/TextField";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import Stack from "@mui/material/Stack";

//Set the type of the props data
export interface Props {
    excelData: any;
    currentDB: string;
}

function BulkMemberUpdater({excelData}: Props, currentDB: string) {
    //console.log(excelData, "DING");
    const [successAlert, setSuccessAlert] = React.useState(false);
    const [errorAlert, setErrorAlert] = React.useState(false);
    const [validationText, setValidationText] = React.useState("");
    const [validationError, setValidationError] = React.useState(false);
    const [loading, setLoading] = React.useState(false);

    let token = localStorage.getItem('jwt');

    const handleValidationClose = () => {
        setValidationError(false);
        setValidationText("");
    }

    const updateMembers = async (memberArray : any[]) => {
        refreshToken();
        if (memberArray.length > 3) {
            memberArray[3] = currentDB;
            memberArray[4] = getWithExpiry('vbapi_Token');
        }
        else {
            memberArray.push(currentDB);
        }
        const response =
            await axios
                .put(
                    localStorage.getItem('baseURL') + 'member/putList',
                    memberArray,
                    {headers: {'Authorization': `Bearer ${token}`, accept: "*/*", "Content-Type": "application/json"}}
                ).then(() => {
                    setLoading(false);
                    setSuccessAlert(true);
                }).catch((error) => {
                    //console.log(response);
                    setLoading(false);
                    setValidationText(error.response.request.responseText);
                    setValidationError(true);
                });
        //console.log(response);
    }

    try {
        //Check for data and that there is a sheet in the data named Census
        if (!isEmpty(excelData) && excelData.Sheets.Members !== undefined) {
            //console.log(excelData, "Made it to formatter!");

            //global function to extract the data into a sequential array of cell data values as well as the column and row ranges
            let sheetDataArray = extractWorkSheetData(excelData.Sheets.Members);

            let rawCellArray: any[] = sheetDataArray[0];

            //console.log(rawCellArray, "Raw Data");

            //we need to find the column index of the values we require so we can grab the data for each row -- THIS IS WHERE COLUMN NAMES ARE SET
            //we add 1 for each for the loop multiplier to account for it being zero based, but later we subtract 1 to account for the very fist row actually starting at zero
            const memberIndexCollection = {
                subscriberIndex: rawCellArray.indexOf('Subscriber ID') + 1,
                memberSegIndex: rawCellArray.indexOf('Member Sequence') + 1,
                // RelationshipIndex: rawCellArray.indexOf('Relationship') + 1,
                // fnIndex: rawCellArray.indexOf('First Name') + 1,
                // mnIndex: rawCellArray.indexOf('Middle Name') + 1,
                // lnIndex: rawCellArray.indexOf('Last Name') + 1,
                // prefixIndex: rawCellArray.indexOf('Prefix') + 1,
                // suffixIndex: rawCellArray.indexOf('Suffix') + 1,
                // dobIndex: rawCellArray.indexOf('DOB') + 1,
                // altIndex: rawCellArray.indexOf('Alt ID') + 1,
                // uniqIndex: rawCellArray.indexOf('Unique ID') + 1,
                // addIndex: rawCellArray.indexOf('Address') + 1,
                // add2Index: rawCellArray.indexOf('Address2') + 1,
                // cityIndex: rawCellArray.indexOf('City') + 1,
                // stateIndex: rawCellArray.indexOf('State') + 1,
                // zipIndex: rawCellArray.indexOf('Zip Code') + 1,
                // hpIndex: rawCellArray.indexOf('Home Phone') + 1,
                // wpIndex: rawCellArray.indexOf('Work Phone') + 1,
                // faxIndex: rawCellArray.indexOf('Fax') + 1,
                // emailIndex: rawCellArray.indexOf('Email') + 1,
                // ethnicityIndex: rawCellArray.indexOf('Ethnicity') + 1,
                // deathDateIndex: rawCellArray.indexOf('Death Date') + 1,
                // sexIndex: rawCellArray.indexOf('Sex') + 1,
                // maritalIndex: rawCellArray.indexOf('Marital Status') + 1,
                // handicapIndex: rawCellArray.indexOf('Handicap') + 1,
                // empDateIndex: rawCellArray.indexOf('Employed Date') + 1,
                // termDateIndex: rawCellArray.indexOf('Terminated Date') + 1,
                // enrollDateIndex: rawCellArray.indexOf('Enrolled Date') + 1,
                // disenrollDateIndex: rawCellArray.indexOf('Disenroll Date') + 1,
            }

            if(memberIndexCollection.subscriberIndex > 0 && memberIndexCollection.memberSegIndex > 0) {
                updateMembers(sheetDataArray);
            }
            else {
                setValidationText("Subscriber ID and Member Sequence are required in order to perform a bulk update.");
                setValidationError(true);
            }

        }
    }
    catch(e) {
        console.log("ERROR", e);

        setErrorAlert(true);
        //clear it out after errors in case of rerendering otherwise the error spams will continue until morale improves
        excelData.Sheets.Members = undefined;
    }
    return (
        <div>
            {successAlert ? <Alert severity='success' onClose={() => setSuccessAlert(false)} variant="filled">
                <AlertTitle>Success!</AlertTitle>
                Member Update Complete!
            </Alert> : <></> }
            {errorAlert ? <Alert severity='error' onClose={() => setErrorAlert(false)} variant="filled">
                <AlertTitle>Error!</AlertTitle>
                There was an error with this file!
            </Alert> : <></> }
            <Dialog
                open={validationError}
                onClose={handleValidationClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                    {"Validation Error"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {validationText}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleValidationClose}>OK</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default React.memo(BulkMemberUpdater)

BulkMemberUpdater.propTypes = {
    excelData: PropTypes.object.isRequired
};